import { maybeLocale } from 'utils/graphql';

const typeParser = (data: { [key: string]: any }) => {
  if (data?.__typename === 'LocaleString' || data?.__typename === 'LocaleImage') {
    return maybeLocale(data);
  }

  return null;
};

const isValidData = <U extends {}>(data: {}, keysToValidate: readonly (keyof U)[]): data is U =>
  // @ts-expect-error TS(2536) Type 'keyof U' cannot be used to index type '{}'.
  keysToValidate.every(key => data[key]);

export const parseData = <U extends {}>(
  data: {} | null | undefined,
  keysToValidate: readonly (keyof U)[]
) => {
  if (!data) {
    return null;
  }
  const parsedData = Object.fromEntries(
    Object.entries(data)
      .map(([key, val]) => [key, typeParser(val as any)])
      .filter(([_, v]) => v)
  );

  return isValidData<U>(parsedData, keysToValidate) ? parsedData : null;
};
